import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/app/services/alert.service';
@Component({
  selector: 'app-add-system-user',
  templateUrl: './add-system-user.component.html',
  styleUrls: ['./add-system-user.component.css']
})
export class AddSystemUserComponent implements OnInit {
  @ViewChild('adduserform') public adduserform: NgForm
  model: any = {};
  id: any;
  opt: any;
  rolename: any;
  role_id: any
  buttonTitle: String = '';
  title: String = '';
  roleList: any = [];
  config = {
    displayKey: "description", //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: 'auto',//height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Select', // text to be displayed when no item is selected defaults to Select,
    // customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    // limitTo: options.length ,// a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more',// text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!',// text to be displayed when no items are found while searching
    searchPlaceholder: 'Search', // label thats displayed in search input,
    searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }
  test: any = [];
  application: any = [];
  applicationLists: any = [];
  app_id: any;
  password: boolean = true;
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private accesscontrolService: AccessControlService,
    private checkPermissionService: CheckPermissionService) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.opt = this.activatedRoute.snapshot.queryParamMap.get('opt')

    if (this.opt == 'add') {
      this.app_id = this.activatedRoute.snapshot.queryParamMap.get('app_id')
    }
    else {
      this.app_id = this.activatedRoute.snapshot.params['app_id'];
    }
    // this.test = ["admin", "manager", "Sysadmin"];
  }

  ngOnInit() {
    if (this.opt == 'add') {
      this.password = true;
      this.checkPermissionService.getAction('add');
      this.buttonTitle = 'Save'
      this.title = 'Add User'
    }
    else {
      this.checkPermissionService.getAction('edit');
      this.password = false;
      this.buttonTitle = 'Update'
      this.title = 'Edit User'
      this.getuserbyId()
    }
    // this.listallapplications();
    this.getapplicationbyId()
    // this.listallRoles_withinApp();
  }
  getapplicationbyId() {
    this.accesscontrolService.getapplicationbyId(this.app_id).subscribe((res) => {
      this.application = res;
      this.model.application_id = this.app_id
      this.model.application_code = this.application.application_code;
      this.model.application_name = this.application.application_name;
    }, error => {
      //console.log(error)
    },
      () => {
        this.listallRoles_withinApp();
      })
  }

  listallRoles_withinApp() {
    this.authService.listallRoles_withinApp(this.model.application_code).subscribe((res) => {
      this.roleList = res
    }, error => {

    }, () => {

    })
  }
  getroleName(role_id: any) {
    this.role_id = role_id;
    this.authService.getrolebyId_users(role_id).subscribe((res) => {
      this.rolename = res["name"]
    }, error => {

    }, () => {

    })
  }

  submit() {
    if (!this.adduserform.valid) {
      return
    }
    if (this.opt == 'add') {
      this.addUser();
    }
    else {
      this.updateUser();
    }
  }
  // listallapplications() {
  //   this.accesscontrolService.listallapplications().subscribe((res) => {
  //     this.applicationLists = res;
  //   }, error => {

  //   }, () => {
  //   })
  // }
  // selected_application(application_id) {
  //   this.app_id = application_id
  //   this.accesscontrolService.getapplicationbyId(application_id).subscribe((res) => {
  //     this.application = res;
  //     this.model.application_id = application_id
  //     this.model.application_code = this.application.application_code;
  //     this.model.application_name = this.application.application_name;
  //   }, error => {
  //     //console.log(error)
  //   },
  //     () => {
  //       this.listallRoles_withinApp();
  //     })
  // }
  //register User
  addUser() {
    this.model.role_name = this.rolename;
    this.authService.addUser(this.model).subscribe((res) => {
    }, error => {
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.alertService.errorAlert(errorMessage)
    }, () => {
      this.alertService.updateAlert("User Added Successfully");
      this.router.navigate(['/system-user-listing/' + this.app_id])
    })
  }
  getuserbyId() {
    this.authService.getuserbyId(this.id).subscribe((res) => {
      this.model = res;
      // for (var i = 0; i < this.model.length; i++) {

      // }
    }, error => {
      //console.log(error)
    },
      () => {

      })
  }
  updateUser() {
    this.model.role_name = this.rolename;
    this.authService.updateUser(this.model).subscribe((res) => {
      this.model = res
    }, error => {
      //console.log(error)
    }, () => {
      this.alertService.updateAlert("User Updated Successfully");
      this.router.navigate(['/system-user-listing/' + this.app_id]);
    })
  }
}

